import updateQuery from 'shared/helpers/updateQuery';
import { HEADER_HEIGHT, TOP_PADDING_FROM_TOOLBAR } from 'crazyEditor/core/constants/editorConstants';
import { store } from 'crazyEditor/redux/store';
import { updateMobileView } from 'crazyEditor/redux/modules/editor/editor';
import { setSelectedElementIds, clearHoveredElementId } from 'crazyEditor/redux/modules/stage/stage';
import { PAGE_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';

export function setEditorMode(mode) {
  updateQuery({mode}, true);
}

export function setViewMode(view) {
  updateQuery({view}, true);
}

export function setViewModeInEditor(view, shouldUpdateMobileView) {
  store.dispatch(setSelectedElementIds(PAGE_ELEMENT_ID));
  store.dispatch(clearHoveredElementId());
  if (shouldUpdateMobileView) {
    store.dispatch(updateMobileView());
  }
  setViewMode(view);
}

export function getStageLayout(pageLayout) {
  const scrollWidth = document.body.clientWidth - window.innerWidth;
  const width = pageLayout.width;
  const height = pageLayout.height;
  const headerHeight = HEADER_HEIGHT;
  const top = HEADER_HEIGHT;
  const topPaddingHeight = TOP_PADDING_FROM_TOOLBAR;
  const editorTop = top + topPaddingHeight;
  const left = Math.max((window.innerWidth - width + scrollWidth) / 2, 0);
  const right = left + width;
  const bottom = editorTop + height;
  const middleX = right / 2;
  const absMiddleY = (bottom + editorTop) / 2;
  const middleY = (window.innerHeight + editorTop) / 2;
  return {
    width, height,
    top, editorTop, bottom, left, right,
    middleX, middleY, absMiddleY,
    headerHeight, topPaddingHeight,
    scrollWidth
  };
}
